import React from 'react'
import InputMask from 'react-input-mask';

function InputMaskWrapper(props) {
    const { onChange, ...rest } = props;

    const handlePaste = (event) => {
        event.preventDefault();
        const pastedValue = event.clipboardData.getData('text/plain');
        event.target.value = pastedValue;
        if (onChange) {
            onChange(event);
        }
    };

    return (
        <InputMask
            {...rest}
            onPaste={handlePaste}
            maskChar=""
            onChange={onChange}
        />
    );
}

export default InputMaskWrapper;